package com.hyperether.goodjob.scenes.jobs.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.verticalScroll
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.models.Job
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.navigation.JobDetails
import com.hyperether.goodjob.scenes.components.JobHeader
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.util.DateTimeUtil
import com.hyperether.goodjob.util.toScaleDp
import kotlinx.datetime.LocalDate

@Composable
fun JobsListWebDashboard(
    sites: Map<String, Site>,
    jobs: List<Map.Entry<Comparable<LocalDate>, List<Job>>>,
    selectedJobs: MutableList<Job>,
    isInEditMode: Boolean,
    navHostController: NavHostController
) {
    val scrollState = rememberScrollState()
    Column(modifier = Modifier.fillMaxSize()
        .verticalScrollbar(scrollState)
        .verticalScroll(scrollState)
        .disableMouseDragScrollOnWeb()
    ) {
        jobs.forEach { (date, jobsForDate) ->
            val formattedDate = if (date is LocalDate) {
                DateTimeUtil.formatDateForDisplay(date)
            } else {
                date.toString()
            }
            if (jobsForDate.isNotEmpty()) {
                Spacer(modifier = Modifier.height(20.toScaleDp()))
                JobHeader(createdAt = formattedDate)
                jobsForDate.forEachIndexed { index, job ->
                    DisableSelection {
                        JobsItemWeb(
                            sites,
                            job = job,
                            isInEditMode = isInEditMode,
                            selectedJobs,
                            isEvenRow = index % 2 == 0,
                            onJobSelected = { selectedJob, isSelected ->
                                if (isSelected) {
                                    selectedJobs.add(selectedJob)
                                } else {
                                    selectedJobs.remove(selectedJob)
                                }
                            },
                            onItemClick = {
                                job.id?.let { navHostController.navigate(JobDetails(it)) }
                            },
                        )
                    }
                }
            }
            Spacer(modifier = Modifier.height(16.toScaleDp()))
        }
    }
}
